<template>
  <div>
    <!-- Layout -->
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { idTramite } }">
                Trámite N.° {{ idTramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Unificación de Procedimientos
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size: 32px; cursor: pointer"
          @click="showModalHelp = true"
        >
          help
        </span>
      </div>
    </div>

    <!-- Info del trámite -->
    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

<!-- Toolbar corregido -->
<div class="d-flex gap-2 mb-3">
  <button
    class="btn btn-outline-primary"
    @click="cargar"
    :disabled="cargando || ejecutando"
  >
    <span class="material-symbols-outlined align-middle">preview</span>
    {{ cargando ? 'Cargando...' : 'Ver Preview' }}
  </button>
  <button
    class="btn btn-outline-secondary"
    @click="dryRun"
    :disabled="cargando || ejecutando"
  >
    <span class="material-symbols-outlined align-middle">play_circle</span>
    {{ ejecutando ? 'Simulando...' : 'Simular' }}
  </button>
  <button
    class="btn btn-success"
    @click="ejecutar"
    :disabled="!hayDatos || ejecutando || cargando"
  >
    <span class="material-symbols-outlined align-middle">merge</span>
    {{ ejecutando ? 'Ejecutando...' : 'Ejecutar Unificación' }}
  </button>
</div>

<!-- Consola de mensajes -->
<div v-if="mensajes.length > 0" class="mb-3">
  <div class="d-flex align-items-center justify-content-between mb-1">
    <span class="fw-bold text-secondary">
      <span class="material-symbols-outlined align-middle">terminal</span>
      Log del proceso
    </span>
    <button class="btn btn-sm btn-outline-secondary" @click="mensajes = []">
      <span class="material-symbols-outlined align-middle" style="font-size:1rem;">
        delete
      </span>
      Limpiar
    </button>
  </div>
  <div class="consola p-3 rounded">
    <div
      v-for="(m, i) in mensajes"
      :key="i"
      class="consola-linea"
      :class="'nivel-' + m.nivel.toLowerCase()"
    >
      <span class="consola-nivel">{{ m.nivel }}</span>
      <span class="consola-mensaje">{{ m.mensaje }}</span>
    </div>
  </div>
</div>

    <!-- Error -->
    <div v-if="error" class="alert alert-danger">
      <span class="material-symbols-outlined align-middle">error</span>
      {{ error }}
    </div>

    <!-- Sin datos -->
    <div v-if="!hayDatos && !cargando && consultado" class="alert alert-success">
      <span class="material-symbols-outlined align-middle">check_circle</span>
      No hay procedimientos pendientes de unificación para este trámite.
    </div>

    <!-- Spinner -->
    <div v-if="cargando" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Tabs por etiqueta -->
    <template v-if="hayDatos">

      <!-- Nav tabs -->
      <ul class="nav nav-tabs mb-0" role="tablist">
        <li
          v-for="(filas, etiqueta) in datos"
          :key="etiqueta"
          class="nav-item"
          role="presentation"
        >
          <button
            class="nav-link"
            :class="{ active: activeTab === etiqueta }"
            @click="activeTab = etiqueta"
            type="button"
          >
            <span class="material-symbols-outlined align-middle"
                  style="font-size:1rem;">biotech</span>
            {{ etiqueta }}
            <span class="badge ms-1"
                  :class="activeTab === etiqueta ? 'bg-white text-primary' : 'bg-primary'">
              {{ filas.length }}
            </span>
          </button>
        </li>
      </ul>

      <!-- Tab content -->
      <div class="tab-content p-3 bg-white rounded-bottom shadow">
        <div
          v-for="(filas, etiqueta) in datos"
          :key="'tab-' + etiqueta"
          v-show="activeTab === etiqueta"
        >
          <!-- Resumen del grupo -->
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="card border-0 px-3 py-2" style="background-color:#f0fdf4;">
              <small class="text-muted">Planillas afectadas</small>
              <span class="fw-bold text-success fs-5">{{ filas.length }}</span>
            </div>
            <div class="card border-0 px-3 py-2" style="background-color:#fff7ed;">
              <small class="text-muted">Códigos a unificar</small>
              <span class="fw-bold text-warning fs-5">
                {{ filas.filter(f => f.c1Cambio).length }} con cambio de elemento
              </span>
            </div>
          </div>

          <!-- Tabla -->
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th rowspan="2" class="align-middle">Planilla</th>
                  <th rowspan="2" class="align-middle">Paciente</th>
                  <th rowspan="2" class="align-middle">Cédula</th>
                  <th
                    colspan="5"
                    class="text-center"
                    style="background-color:#bbf7d0; color:#166534;"
                  >
                    Código que se MANTIENE
                  </th>
                  <th
                    colspan="3"
                    class="text-center"
                    style="background-color:#fecaca; color:#991b1b;"
                  >
                    Código que se ANULA
                  </th>
                </tr>
                <tr>
                  <th style="background-color:#dcfce7; color:#166534;">Código</th>
                  <th style="background-color:#dcfce7; color:#166534;">Descripción</th>
                  <th style="background-color:#dcfce7; color:#166534;">Cantidad</th>
                  <th style="background-color:#dcfce7; color:#166534;">Elemento actual</th>
                  <th style="background-color:#dcfce7; color:#166534;">Elemento nuevo</th>
                  <th style="background-color:#fee2e2; color:#991b1b;">Código</th>
                  <th style="background-color:#fee2e2; color:#991b1b;">Descripción</th>
                  <th style="background-color:#fee2e2; color:#991b1b;">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="f in filas" :key="f.idPlanilla + '-' + f.c1Codigo" @dblclick="abrirPlanillaPopup(f.idPlanilla)">
                  <td class="fw-bold">{{ f.planillaNumero }}</td>
                  <td>{{ f.planillaNombre }}</td>
                  <td>{{ f.planillaCedula }}</td>
                  <!-- c1 -->
                  <td>
                    <span class="badge bg-success">{{ f.c1Codigo }}</span>
                  </td>
                  <td>{{ f.c1Descripcion }}</td>
                  <td class="text-center">{{ f.c1Cantidad }}</td>
                  <td class="text-muted" style="font-size:0.85rem;">
                    {{ f.c1ElementoActual }}
                  </td>
                  <td>
                    <span v-if="f.c1Cambio" class="text-success fw-bold">
                      <span
                        class="material-symbols-outlined align-middle"
                        style="font-size:1rem;"
                      >arrow_forward</span>
                      {{ f.c1ElementoNuevo }}
                    </span>
                    <span v-else class="badge bg-secondary">Sin cambio</span>
                  </td>
                  <!-- c2 -->
                  <td>
                    <span class="badge bg-danger">{{ f.c2Codigo }}</span>
                  </td>
                  <td>{{ f.c2Descripcion }}</td>
                  <td class="text-center">{{ f.c2Cantidad }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal Ayuda -->
    <div v-if="showModalHelp" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <span class="material-symbols-outlined align-middle">help</span>
              Ayuda — Unificación de Procedimientos
            </h5>
            <button type="button" class="btn-close" @click="showModalHelp = false" />
          </div>
<div class="modal-body">
  <p>
    Este proceso identifica planillas que tienen registrados procedimientos
    que deben unificarse en un único código consolidado.
  </p>
  <ol>
    <li>
      <strong>Ver Preview</strong>: consulta los cambios pendientes
      sin modificar datos.
    </li>
    <li>
      <strong>Simular</strong>: ejecuta el proceso en modo DRY-RUN
      y muestra el log detallado sin modificar datos.
    </li>
    <li>
      <strong>Ejecutar Unificación</strong>: aplica los cambios
      definitivamente y muestra el log de lo ejecutado.
    </li>
  </ol>
  <p class="text-muted">
    Los códigos anulados quedan inactivos para auditoría.
  </p>
</div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModalHelp = false">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showModalHelp"
      class="modal-backdrop fade show"
      @click="showModalHelp = false"
    />

  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import api from "@/services/api";
import { abrirPlanillaPopup } from "@/assets/js/popup.js";

export default {
  name: "UnificacionProcedimientos",

  components: { Layout },

  props: {
    p_idtramite: { type: String, required: true }
  },

  data() {
    return {
      idTramite:     Number(this.p_idtramite),
      datos:         {},
      activeTab:     "",
      cargando:      false,
      ejecutando:    false,
      consultado:    false,
      error:         null,
      showModalHelp: false,
      datosTramite:  "",
      mensajes:      [],
    };
  },

  computed: {
    hayDatos() {
      return Object.keys(this.datos).length > 0;
    }
  },

  async mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },

  methods: {
    async cargar() {
      this.cargando   = true;
      this.error      = null;
      this.consultado = false;
      try {
        const { data } = await api.get("/unificacion/preview", {
          params: { idTramite: this.idTramite }
        });
        this.datos = data;
        // Activar el primer tab automáticamente
        const claves = Object.keys(data);
        this.activeTab = claves.length > 0 ? claves[0] : "";
      } catch (e) {
        this.error = "Error al cargar el preview: " + e.message;
      } finally {
        this.cargando   = false;
        this.consultado = true;
      }
    },

async dryRun() {
  this.ejecutando = true;
  this.mensajes   = [];
  this.error      = null;
  try {
    const { data } = await api.post("/unificacion/dry-run", null, {
      params: { idTramite: this.idTramite }
    });
    this.mensajes = data;
  } catch (e) {
    this.error = "Error en simulación: " + e.message;
  } finally {
    this.ejecutando = false;
  }
},

async ejecutar() {
  if (!confirm("¿Confirmar unificación? Esta acción modificará los datos.")) return;
  this.ejecutando = true;
  this.mensajes   = [];
  this.error      = null;
  try {
    const { data } = await api.post("/unificacion/ejecutar", null, {
      params: { idTramite: this.idTramite }
    });
    this.mensajes = data;
    await this.cargar();
  } catch (e) {
    this.error = "Error al ejecutar: " + e.message;
  } finally {
    this.ejecutando = false;
  }
},

  abrirPlanillaPopup(idPlanilla) {
    abrirPlanillaPopup(idPlanilla);
  },
  }
};
</script>

<style scoped>
.modal-content {
  background-color: #f9fafb;
}
.tab-content {
  border: 1px solid #dee2e6;
  border-top: none;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th {
  background-color: #e0f2fe;
  color: #0369a1;
  font-weight: bold;
  padding: 0.5rem;
  border: 1px solid #bae6fd;
}
td {
  padding: 0.5rem;
  border: 1px solid #e0f2fe;
}
tr:nth-child(even) {
  background-color: #f0f9ff;
}
tr:hover {
  background-color: #dbeafe;
}
.consola {
  background-color: #1e1e2e;
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  max-height: 300px;
  overflow-y: auto;
}
.consola-linea {
  display: flex;
  gap: 0.75rem;
  padding: 2px 0;
  border-bottom: 1px solid #2a2a3e;
}
.consola-nivel {
  min-width: 70px;
  font-weight: bold;
  text-align: center;
  border-radius: 3px;
  padding: 0 4px;
}
.consola-mensaje {
  color: #cdd6f4;
}
.nivel-ok     .consola-nivel { background-color: #166534; color: #bbf7d0; }
.nivel-info   .consola-nivel { background-color: #1e3a5f; color: #bae6fd; }
.nivel-skip   .consola-nivel { background-color: #3f3f00; color: #fef08a; }
.nivel-error  .consola-nivel { background-color: #7f1d1d; color: #fecaca; }
</style>